import { tradeTypeOptions } from '../../../../partials/AlgosList/Algotable/Cells/CellTradeType';

export function searchTradingType(tradingType = '', searchTerm = '') {
  let toReturn = false;

  const searchTermFormatted = searchTerm.replace('(n)', 'n');

  if (!searchTermFormatted) {
    return toReturn;
  }

  const targetOption =
    tradeTypeOptions.find((item) => item.value === tradingType)?.simpleLabel ||
    tradeTypeOptions.find((item) => item.value === tradingType)?.label ||
    '';

  if (targetOption?.toLowerCase()?.includes(searchTermFormatted)) {
    toReturn = true;
  }

  return toReturn;
}
